import { render, staticRenderFns } from "./rentabilidade-chart.vue?vue&type=template&id=6077e22d&"
import script from "./rentabilidade-chart.vue?vue&type=script&lang=js&"
export * from "./rentabilidade-chart.vue?vue&type=script&lang=js&"
import style0 from "./rentabilidade-chart.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6077e22d')) {
      api.createRecord('6077e22d', component.options)
    } else {
      api.reload('6077e22d', component.options)
    }
    module.hot.accept("./rentabilidade-chart.vue?vue&type=template&id=6077e22d&", function () {
      api.rerender('6077e22d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/rentabilidade-chart/rentabilidade-chart.vue"
export default component.exports